import { render, staticRenderFns } from "./createNewAccount.vue?vue&type=template&id=67098a7d&scoped=true"
import script from "./createNewAccount.vue?vue&type=script&lang=js"
export * from "./createNewAccount.vue?vue&type=script&lang=js"
import style0 from "./createNewAccount.vue?vue&type=style&index=0&id=67098a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67098a7d",
  null
  
)

export default component.exports